import {length, substring} from 'stringz';

export function ellipsisIfNeeded(text: string, maxCharacters: number): string {
    const suffix = "...";
    return length(text) < maxCharacters ? text : `${substring(text, 0, maxCharacters - suffix.length)}${suffix}`;
}
